
import { LabelValue } from '../../shared/shared.interface';
import { KngMydealerState } from './definitions';

export class KngMydealerFactory 
{
	public static build(): KngMydealerState 
	{
		return {
			myDealer: {
				firstName: '',
				lastName: '',
				phone: this.getPhoneEmail('phone'),
				email: this.getPhoneEmail('email'),
				address: {
					label: '',
					value: {
						addressLine1: '',
						addressLine2: '',
						city: '',
						state: '',
						zipCode: ''
					},
					icon: {
						iconPath: '/assets/location.svg',
						altText: ''
					}
				}
			},
			isButton: false,
			button: {
				size: 'medium',
				style: 'secondary',
				disabled: false,
				label: 'Open Contact Form',
				position: 'right',
				icon: {
					altText: '',
					iconPath: 'assets/external_link.svg'
				}
			},
			url: '',
			isError: false,
			loading: false,
			noResult: {
				label: '',
				text: '',
				iconPath: '',
				altText: ''
			}
		};
	}
	public static getPhoneEmail(type: string): LabelValue 
	{
		let iconValue = '';
		switch (type) 
		{
		case 'email':
			iconValue = '/assets/email.svg';
			break;

		case 'phone':
			iconValue = '/assets/phone.svg';
			break;
		}

		const obj: LabelValue = { label: '', value: '', icon: { iconPath: iconValue, altText: '' } };
		return obj;
	}
}
